// Toast 消息提示工具 - 使用居中弹窗
let messageDialogInstance = null

export const initMessageDialog = (instance) => {
  messageDialogInstance = instance
}

export const Toast = {
  success(message, title = null, duration = 2000) {
    if (!messageDialogInstance) {
      console.warn('MessageDialog not initialized')
      return
    }
    messageDialogInstance.show({
      type: 'success',
      title,
      message,
      duration
    })
  },

  error(message, title = null, duration = 3000) {
    if (!messageDialogInstance) {
      console.warn('MessageDialog not initialized')
      return
    }
    messageDialogInstance.show({
      type: 'error',
      title,
      message,
      duration
    })
  },

  warning(message, title = null, duration = 2500) {
    if (!messageDialogInstance) {
      console.warn('MessageDialog not initialized')
      return
    }
    messageDialogInstance.show({
      type: 'warning',
      title,
      message,
      duration
    })
  },

  info(message, title = null, duration = 2000) {
    if (!messageDialogInstance) {
      console.warn('MessageDialog not initialized')
      return
    }
    messageDialogInstance.show({
      type: 'info',
      title,
      message,
      duration
    })
  },

  // 清除所有提示
  clear() {
    if (messageDialogInstance) {
      messageDialogInstance.close()
    }
  }
}

// Vue 插件方式安装
export default {
  install(Vue) {
    Vue.prototype.$toast = Toast
  }
}
